import Sidebar from "./sidebar";
import Mufasa from "./Mufasa";

export default function Homeland() {
  return (
    <div>
      <Sidebar />
      <Mufasa />
    </div>
  );
}
